import { useEffect, useState } from 'react';
import { approvalFlowAPI } from '../services/api';

// Which approval buttons the signed-in user should see for an activity, from
// Settings → Approval Flow (the server enforces the same rules on submit).
//   canEarlier — may sign a level before the last one ("Pending Approval")
//   canFinal   — may sign the last level ("Pending QA Approval" / final approval)
//   earlierLabel / finalLabel — button wording, from the level names set there
// Super Admin can always sign. The flows are fetched once and shared.
let flowsPromise = null;
const loadFlows = () => {
  if (!flowsPromise) {
    flowsPromise = approvalFlowAPI.getAll()
      .then((res) => res.data.data || [])
      .catch(() => { flowsPromise = null; return []; });
  }
  return flowsPromise;
};
export const invalidateApprovalFlows = () => { flowsPromise = null; };

const currentUser = () => {
  try { return JSON.parse(localStorage.getItem('user') || '{}'); } catch { return {}; }
};

const onLevel = (level, user) => !!level && (
  (level.roles || []).includes(user.role) || (level.user_ids || []).map(Number).includes(Number(user.user_id))
);

const useApprovalRights = (workflowType) => {
  const [rights, setRights] = useState({ canEarlier: false, canFinal: false, earlierLabel: 'Approval', finalLabel: 'QA Approval', levels: [], enabled: true, loaded: false });

  useEffect(() => {
    let alive = true;
    loadFlows().then((flows) => {
      if (!alive) return;
      const user = currentUser();
      const flow = flows.find((f) => f.workflow_type === workflowType);
      const levels = flow?.levels || [];
      const superAdmin = String(user.role || '').toLowerCase() === 'super admin';
      const last = levels[levels.length - 1];
      setRights({
        canEarlier: superAdmin || levels.slice(0, -1).some((l) => onLevel(l, user)) || (levels.length === 1 && onLevel(last, user)),
        canFinal: superAdmin || onLevel(last, user),
        // With more than one earlier level the button signs whichever is current, so it stays generic.
        earlierLabel: (levels.length === 2 && levels[0].level_label?.trim()) || 'Approval',
        finalLabel: (levels.length > 1 && last.level_label?.trim()) || 'QA Approval',
        levels,
        enabled: flow ? flow.enabled !== false : true,
        loaded: true,
      });
    });
    return () => { alive = false; };
  }, [workflowType]);

  return rights;
};

export default useApprovalRights;
